(function () {
  var STYLE_ID = 'rd-compare-price-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.rd-price{display:flex!important;align-items:baseline!important;gap:8px!important;flex-wrap:wrap!important;}' +
      '.rd-price__compare{text-decoration:line-through;opacity:.55;font-size:.85em;}' +
      '.rd-price__compare[hidden]{display:none!important;}';
    document.head.appendChild(style);
  }

  function formatLike(sampleText, minorUnits) {
    var decimals = 2;
    var dotIndex = sampleText.indexOf('.');
    if (dotIndex !== -1) decimals = sampleText.length - dotIndex - 1;
    return (minorUnits / 100).toFixed(decimals);
  }

  function getCosmeticConversion() {
    try {
      var currency = sessionStorage.getItem('cosmeticCurrency');
      if (!currency || currency === 'OMR') return null;
      var cached = JSON.parse(localStorage.getItem('cosmeticCurrencyRates') || 'null');
      if (!cached || !cached.rates) return null;
      var usdToStore = cached.rates['OMR'];
      var usdToTarget = cached.rates[currency];
      if (!usdToStore || !usdToTarget) return null;
      return { currency: currency, rate: usdToTarget / usdToStore };
    } catch (e) {
      return null;
    }
  }

  function formatCosmetic(amount) {
    var rounded = Math.round(amount / 10) * 10;
    return rounded.toLocaleString('en-US', { maximumFractionDigits: 0 });
  }

  function setup(productEl) {
    if (productEl.dataset.rdCompareReady === 'true') return;

    var priceEl = productEl.querySelector('[data-rd-price]');
    var variantInput = productEl.querySelector('[data-rd-variant-input]');
    if (!priceEl) return;

    var path = window.location.pathname.replace(/\.js$/, '');

    fetch(path + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data || !data.variants || !data.variants.length) return;
        productEl.dataset.rdCompareReady = 'true';

        var compareEl = document.createElement('span');
        compareEl.className = 'rd-price__compare';
        compareEl.setAttribute('hidden', '');
        compareEl.setAttribute('data-rd-price-compare', '');
        compareEl.setAttribute('data-cosmetic-amount', '');
        priceEl.insertBefore(compareEl, priceEl.firstChild);

        function currentVariantId() {
          if (variantInput && variantInput.value) return String(variantInput.value);
          var params = new URLSearchParams(window.location.search);
          return params.get('variant') || String(data.variants[0].id);
        }

        function update() {
          var id = currentVariantId();
          var variant = null;
          for (var i = 0; i < data.variants.length; i++) {
            if (String(data.variants[i].id) === id) {
              variant = data.variants[i];
              break;
            }
          }
          if (!variant) return;

          var sampleText = '';
          var childNodes = priceEl.childNodes;
          for (var j = 0; j < childNodes.length; j++) {
            var node = childNodes[j];
            if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
              sampleText = node.textContent.trim();
              break;
            }
          }

          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            var conversion = getCosmeticConversion();
            if (conversion) {
              compareEl.textContent = formatCosmetic((variant.compare_at_price / 100) * conversion.rate);
              compareEl.dataset.cosmeticLast = compareEl.textContent;
            } else {
              compareEl.textContent = formatLike(sampleText || '0.00', variant.compare_at_price);
              delete compareEl.dataset.cosmeticLast;
            }
            compareEl.removeAttribute('hidden');
          } else {
            compareEl.setAttribute('hidden', '');
          }
        }

        update();
        [500, 1200, 2500].forEach(function (delay) {
          setTimeout(update, delay);
        });

        productEl.addEventListener('click', function (event) {
          if (event.target.closest && event.target.closest('[data-rd-option-choice]')) {
            setTimeout(update, 60);
          }
        });
      })
      .catch(function () {});
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var products = scope.querySelectorAll ? scope.querySelectorAll('.rd-product') : [];
    if (!products.length && scope.matches && scope.matches('.rd-product')) {
      products = [scope];
    }
    if (!products.length) return;
    injectStyle();
    Array.prototype.forEach.call(products, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
